//export const YOU_TUBE_SEARCH_ENDPOINT =
//    'https://www.googleapis.com/youtube/v3/search';
export const YOU_TUBE_SEARCH_ENDPOINT =
    'https://www.googleapis.com/youtube/v3/playlistItems';

export const KNITANDNOTE_YOUTUBE_CHANNEL_ID = 'UCBGb2JA8oAFKvTLPvLXa5lw';

export const ENGLISH_TUTORIALS_PLAYLIST_ID =
    'PLCswEzDPAwYoo58LlTS-9bw18FrSKHBfr';

export const NORWEGIAN_TUTORIALS_PLAYLIST_ID =
    'PLCswEzDPAwYr_aZrUK6GqBSi63nLD6R9N';

export const youTubePlayerOpts = {
    height: 'auto',
    width: '100vw',
    playerVars: {
        autoplay: 1,
        origin: window.location.origin,
        enablejsapi: 1,
    },
};
